import { RemarkCategoryHierarchyGeneratedEntity } from "./generated/RemarkCategoryHierarchyGeneratedEntity";

export abstract class RemarkCategoryHierarchyEntity extends RemarkCategoryHierarchyGeneratedEntity {
    // Comment to preserve new line
}
